import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Space,
  message,
  Col,
  Row,
  Card,
} from "antd";
import InputSelect from "./InputSelect";
import InputText from "./InputText";

const getItemsNames = (data) => {
  if (!data) {
    return [];
  }
  // Map through the Table6 array to extract item names and IDs
  return data.map((item) => ({
    label: item.ItemName, // Use ItemName for the label
    value: item.ItemName, // Use ItemId for the value
  }));
};

const DemandForm = ({ dataSet, drawerTableData, setDrawerTableData, title }) => {
  const [form] = Form.useForm();
  const itemsOptions = getItemsNames(dataSet?.Table6);

  const handleFinish = async (values) => {
    const { ItemCode, ItemName, Quantity } = values;
  
    if (!ItemCode && !ItemName) {
      message.error("You must enter either Item Code or Item Name.");
      return;
    }
  
    if (!Quantity || Quantity <= 0) {
      message.error("Quantity must be a positive number.");
      return;
    }
  
    // Find the item based on ItemCode or ItemName
    let item = null;
    if (ItemCode) {
      item = dataSet.Table6.find((record) => record.ItemCode === ItemCode);
    }
    if (!ItemCode && ItemName) {
      item = dataSet.Table6.find((record) => record.ItemName === ItemName);
    }
  
    if (!item) {
      message.error("Item not found.");
      return;
    }
  
    // Create new item with quantity
    const newItem = {
      ...item,
      Quantity: parseFloat(Quantity),
    };
  
    // Check if the item already exists in the drawerTableData
    const itemExists = drawerTableData.some((existingItem) => 
      existingItem.ItemCode === newItem.ItemCode || existingItem.ItemName === newItem.ItemName
    );
  
    if (itemExists) {
      message.error("Item already exists in the list.");
      return;
    }
  
    // Update state with new item
    setDrawerTableData((prevData) => [...prevData, newItem]);
  
    console.log("checking the insert ", newItem);
    form.resetFields();
  };
  

  return (
    <Card title={title}>
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Row gutter={16}>
          <Col span={6}>
            <InputText label="Item Code" name="ItemCode" type="number" />
          </Col>
          <Col span={6}>
            <InputSelect
              label="Item Name"
              name="ItemName"
              options={itemsOptions}
            />
          </Col>
          <Col span={6}>
            <InputText label="Quantity" name="Quantity" type="number" />
          </Col>
          <Col span={6} style={{ display: "flex", alignItems: "center" }}>
            <Form.Item style={{ width: "100%", marginTop: "22px" }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
              >
                Insert
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default DemandForm;
